<template>
  <el-dialog
    title="申请平台介入"
    :visible.sync="dialogVisible"
    width="45%"
    :before-close="handleClose">
    <div class="content">
      <div class="tips">
        <i class="el-icon-info"></i>
        <span>平台介入根据买卖双方提供资料决定此笔订单处理结果，请按实际情况提交佐证资料。</span>
      </div>
      <div class="label">请填写申请资料</div>
      <el-input type="textarea" :autosize="{'minRows': 5}"
                maxlength="160" show-word-limit
                v-model="appealMemo" placeholder="请根据实际情况填写相关信息"></el-input>
    </div>
    <div class="dialog-footer" slot="footer">
      <el-button @click="hide">取消</el-button>
      <el-button type="primary" :loading="loading" @click="platformIn">确定</el-button>
    </div>
  </el-dialog>
</template>

<script type="text/ecmascript-6">
import {fetchRefundAppeal} from '../../../api/xunyou';
export default {
  name: 'refundAppeal',
  data() {
    return {
      loading: false,
      dialogVisible: false,
      appealMemo: '',
      refundData: null
    }
  },
  methods: {
    handleClose (done) {
      this.appealMemo = '';
      this.refundData = null;
      done();
    },
    show (data) {
      this.refundData = data;
      this.dialogVisible = true;
    },
    hide () {
      this.dialogVisible = false;
      this.appealMemo = '';
      this.refundData = null;
    },
    platformIn () {
      if (!this.appealMemo) {
        this.$message.warning('请输入申请资料');
        return ;
      }
      const params = {
        asOid: this.refundData.asOid,
        regHandlerApplyMemo: this.appealMemo
      }
      this.loading = true;
      fetchRefundAppeal(params)
        .then(res => {
          console.log('平台介入：', res)
          if (res.code === 0) {
            this.refundData.regHandlerStatus = res.data.regHandlerStatus;
            this.refundData.regHandlerApplyTime = res.data.regHandlerApplyTime;
            this.refundData.regHandlerApplyMemo = res.data.regHandlerApplyMemo;
            this.refundData.regHandlerTime = res.data.regHandlerTime;
            this.refundData.regHandlerMemo = res.data.regHandlerMemo;
            this.refundData.enableAppeal = false;
            this.hide();
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch(err => {
          console.error('错误：', err);
        })
        .finally(() => {
          this.loading = false;
        })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" rel="stylesheet/less" scoped>
.tips{
  color: #ff7a30;
}
.label{
  margin-top: 15px;
  margin-bottom: 5px;
}
</style>



// WEBPACK FOOTER //
// src/views/myOrder/customerService/refundAppeal.vue